import { CheckIcon, PlusIcon } from '@heroicons/react/20/solid'
import { useEffect, useState } from 'react'
import { graphql, useLazyLoadQuery } from 'react-relay'
import type { planQuery as PlanQueryType, } from './__generated__/planQuery.graphql'
import { PlanType, Tiers } from '@/defines/requestDefines'
import { useOrganization, useOrganizationList, useUser } from '@clerk/clerk-react'
import { OrganizationInvitationResource, OrganizationMembershipResource } from '@clerk/types'
import { useUserStore } from '@/defines/store/userStore'
import axios from 'axios'
import AlertService from '@/defines/service/alertService'
import InsuranceService from '@/defines/service/insuranceService'
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import { TrashIcon } from '@heroicons/react/24/outline'
import LoadingService from '@/defines/service/loadingService'
import CommonService from '@/defines/service/commonService'
import { useNavigate } from 'react-router-dom'
// import { useUserStore } from '@/defines/store/userStore'

interface agnetData {
    id: string;
    insurance_org: {
        customplanprice: number | null | undefined;
        expireddate: any | null | undefined;
        id: string;
        insurance_agents: ReadonlyArray<{
            id: string;
            name: string;
            orgid: string | null | undefined;
            personalplanexpireddate: Date | null | undefined;
            phoneNumbers: ReadonlyArray<string>;
            plantype: number;
        }>;
        managerid: string;
        numberofperson: number | null | undefined;
        orgId: string;
        palnType: number;
        valid: boolean;
    } | null | undefined;
    name: string;
    orgid: string | null | undefined;
    personalplanexpireddate: Date | null | undefined;
    phoneNumbers: ReadonlyArray<string>;
    plantype: number;
}

export const PlanQuery = graphql`
    query planQuery(
        $userId: String
    ) {
        insurance_agent_connection(where: {id: {_eq: $userId}}) {
            edges {
                node {
                    id
                    name
                    orgid
                    personalplanexpireddate
                    plantype
                    phoneNumbers
                    insurance_org {
                        customplanprice
                        expireddate
                        id
                        managerid
                        orgId
                        numberofperson
                        palnType
                        valid
                        insurance_agents {
                            id
                            name
                            orgid
                            personalplanexpireddate
                            plantype
                            phoneNumbers
                        }
                    }
                }
            }
        }
    }
`

function classNames(...classes: any) {
    return classes.filter(Boolean).join(' ')
}

export default function Plan() {
    const alertService = AlertService();
    const loadingService = LoadingService();
    const userId = useUserStore.getState().userData.id;
    const [inviteEmail, setInviteEmail] = useState('');
    const [invite, setInvite] = useState([] as OrganizationInvitationResource[]);
    const [membership, setMembership] = useState([] as OrganizationMembershipResource[]);
    const [isManager, setIsManager] = useState(false)
    const [data, setData] = useState({} as agnetData)
    const [sending, setSending] = useState(false);
    const [orgSelector, setOrgSelector] = useState(false);
    const [orgName, setOrgName] = useState('');
    const [currentTier, setCurrentTier] = useState(Tiers[0])
    const { setActive } = useOrganizationList();
    const { user } = useUser();
    const [ableUseOrgInvite, setAbleUseOrgInvite] = useState(false)

    const { isLoaded, organization, invitations } = useOrganization()
    const navigate = useNavigate();

    useEffect(() => {
        console.log('userId', userId);	
        handleOrganizationMemberships();
    }, []);

    const loadOrgRelations = () => {
        if (!isLoaded)
            return;
        console.log('organization', organization);
        organization?.getInvitations()
            .then((res) => {
                console.log('getInvitations', res);
                setInvite(res.data.filter(item => item.status === "pending"));
            })

        organization?.getMemberships()
            .then((res) => {
                setMembership(res.data);
                console.log('getMemberships', res);
                console.log('userId', userId);
            });
        console.log(invitations);
    }
    const sendInvite = () => {
        organization?.inviteMember({
            emailAddress: inviteEmail,
            role: 'org:insurance_agent' // org:insurance_agent
        }).then((res) => {
            setInviteEmail('');
            loadOrgRelations();
            alertService.Success('成功寄出邀請 ! ');
            console.log('成功寄出邀請 ! ', res);
        }).catch((err) => {
            alertService.Error('寄出邀請失敗 ! ' + err);
            console.log('寄出邀請失敗 ! ', err);
        });
    }
    const revokeInvite = (obj: OrganizationInvitationResource) => {
        obj.revoke().then((res) => {
            setInviteEmail('');
            loadOrgRelations();
            alertService.Success('成功刪除邀請 ! ');
            console.log('成功刪除邀請 ! ', res);
        }).catch((err) => {
            alertService.Error('刪除邀請失敗 ! ' + err);
            console.log('刪除邀請失敗 ! ', err);
        });
    }
    const destroyMembership = (obj: OrganizationMembershipResource) => {
        obj.destroy().then((res) => {
            setInviteEmail('');
            loadOrgRelations();
            alertService.Success('成功刪除使用者 ! ');
            console.log('成功刪除使用者 ! ', res);
        }).catch((err) => {
            alertService.Error('刪除使用者失敗 ! ' + err);
            console.log('刪除使用者失敗 ! ', err);
        });
    }

    const planData = useLazyLoadQuery<PlanQueryType>(
        PlanQuery,
        { userId: userId },
    );


    useEffect(() => {
        console.log(planData);
        if (planData.insurance_agent_connection?.edges && planData.insurance_agent_connection.edges.length > 0) {
            setData(planData.insurance_agent_connection.edges[0].node);
        }
    }, [planData]);

    useEffect(() => {
        if (!data || !data.id)
            return;
        console.log(data);
        if (data.plantype && data.plantype > 0) {
            setCurrentTier(Tiers.filter(item => item.planType === data.plantype)[0]);
        }
        if (CommonService().DecodeNodeId(data.id) === data.insurance_org?.managerid) {
            setIsManager(true);
            loadOrgRelations();
        }
    }, [data]);

    const choisePlan = async (planType: PlanType, orgName: string | undefined = undefined) => {
        if (planType === PlanType.group && (!orgName || orgName == '')) {
            setOrgSelector(true);
            return;
        }
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${useUserStore.getState().token}`
        }
        const payload = {
            planType: planType,
            orgName: ''
        };
        if (planType === PlanType.group) {
            if (!orgName) {
                alertService.Error(`請提供組織名稱 ! `);
                return;
            }
            payload.orgName = orgName!;
        }

        setSending(true);
        setOrgSelector(false);
        loadingService.ShowLoading("正在處理升級...");
        // Send POST request to your Lambda endpoint
        axios.post(import.meta.env.VITE_SERVERLESS_API + '/insurance/change-plan', payload, { headers: headers })
            .then((response) => {
                console.log('change plan res = ', response);
                navigate('/after-login?type=insuranceUpgrade');
                alertService.Success(`${response?.data} ! `);
                setCurrentTier(Tiers[planType]);
                setSending(false);
                loadingService.HiddenLoading();
                InsuranceService().InitData(useUserStore.getState().userData.id);
                handleOrganizationMemberships();
            })
            .catch((error) => {
                loadingService.HiddenLoading();
                alertService.Error(`失敗 ! ${error?.response?.data}`);
                console.log('change plan error = ', error);
                setSending(false);
            });
    };

    // Handle organization memberships
    const handleOrganizationMemberships = () => {
        console.log('user.organizationMemberships', user?.organizationMemberships);
        if (user?.organizationMemberships && user.organizationMemberships.length > 0) {
            if (user.organizationMemberships.length > 1) {
                user.organizationMemberships.forEach((org: any) => {
                    setAbleUseOrgInvite(true);
                    if (org.organization.id !== import.meta.env.VITE_DEFAULT_INSURANCE_ORG_ID) {
                        void setActive!({ organization: org.organization.id });
                        loadOrgRelations();
                    }
                });
            }
        }
    };

    return (
        <>
            <Dialog open={orgSelector} onClose={() => { setOrgSelector(false) }} className="relative z-10">
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity 
                            data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 
                            data-[enter]:ease-out data-[leave]:ease-in"
                />

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <DialogPanel
                            transition
                            style={{ width: '80vw', maxHeight: '80vh', overflowY: 'auto' }}
                            className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all  
                                    data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out 
                                    data-[leave]:ease-in sm:my-8 sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                        >
                            <div className="">
                                <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                                    <DialogTitle className="text-lg font-semibold leading-6 text-gray-900">
                                        請提供組織名稱
                                    </DialogTitle>

                                    <label htmlFor="email" className="block mt-2 text-sm font-medium leading-6 text-gray-900">
                                        組織名稱
                                    </label>
                                    <input
                                        id="telephone"
                                        name="telephone"
                                        type="text"
                                        autoComplete="telephone"
                                        value={orgName}
                                        onChange={(e) => setOrgName(e.target.value)}
                                        className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 
                            focus:ring-2 focus:ring-inset focus:ring-red-400 sm:text-sm sm:leading-6"
                                    />

                                </div>
                            </div>

                            <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                                <button
                                    type="button"
                                    onClick={() => setOrgSelector(false)}
                                    className="my-3 md:mx-3 inline-flex w-full justify-center rounded-md ring-red-400 text-red-400 px-3 py-2 text-sm 
                          font-semibold shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-red-300 hover:text-white sm:mt-0 sm:w-auto"
                                >
                                    返回
                                </button>

                                <button
                                    type="button"
                                    disabled={sending}
                                    onClick={() => { choisePlan(PlanType.group, orgName); }}
                                    className="my-3 md:mx-3 inline-flex w-full justify-center rounded-md bg-red-400 px-3 py-2 text-sm font-semibold 
                          text-white shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-red-300 sm:mt-0 sm:w-auto"
                                >
                                    確定升級
                                </button>
                            </div>

                        </DialogPanel>
                    </div>
                </div>
            </Dialog>
            {
            
                data.plantype == PlanType.none || data.plantype == PlanType.freeTrial ?
                    <div className="flex justify-center items-center">
                        <div className="bg-white py-12 sm:py-32">
                            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                                <div className="mx-auto max-w-4xl text-center">
                                    <h2 className="text-base/7 font-semibold text-teal-600">價格</h2>
                                    <p className="mt-2 text-balance text-5xl font-semibold tracking-tight text-gray-900">
                                        您的方案
                                    </p>
                                </div>
                                <p className="mx-auto mt-6 max-w-2xl text-pretty text-center text-lg font-medium text-gray-600 sm:text-xl/8">
                                    我們的方案主要區分在於AI諮詢數量，以及關懷之次數。我們會協助您使用此資金投資到您與您客戶的關係之中 !
                                </p>
                                <p className="mx-auto mt-6 max-w-2xl text-pretty text-center text-lg font-medium text-gray-600 sm:text-xl/8">
                                    你的客戶，我們照顧。
                                </p>
                                <div className="isolate mx-auto mt-10 grid max-w-md grid-cols-1 gap-8 md:max-w-2xl md:grid-cols-2 lg:max-w-4xl xl:mx-0 xl:max-w-none xl:grid-cols-3">
                                    {Tiers.filter(e => e.show).map((tier) => (
                                        <div
                                            key={tier.planType}
                                            className={classNames(
                                                tier.planType == currentTier.planType ? 'ring-2 ring-teal-600' : 'ring-1 ring-gray-200',
                                                'rounded-3xl p-8',
                                            )}
                                        >
                                            <h3
                                                id={tier.planType.toString()}
                                                className={classNames(
                                                    tier.planType == currentTier.planType ? 'text-teal-600' : 'text-gray-900',
                                                    'text-lg/8 font-semibold',
                                                )}
                                            >
                                                {tier.name}
                                            </h3>
                                            <p className="mt-4 text-sm/6 text-gray-600">{tier.description}</p>
                                            <p className="mt-6 flex items-baseline gap-x-1">
                                                <span className="text-4xl font-semibold tracking-tight text-gray-900">
                                                    {tier.price}
                                                </span>
                                            </p>
                                            <button
                                                disabled={tier.planType == currentTier.planType || sending}
                                                onClick={() => {
                                                    console.log('choisePlan', tier.planType);
                                                    choisePlan(tier.planType);
                                                }}
                                                className={classNames(
                                                    tier.planType == currentTier.planType
                                                        ? 'text-teal-600 ring-1 ring-inset ring-teal-200 hover:ring-teal-300'
                                                        : 'bg-teal-600 text-white shadow-sm hover:bg-teal-500',

                                                    'mt-6 w-full block rounded-md px-3 py-2 text-center text-sm/6 font-semibold focus-visible:outline focus-visible:outline-2',
                                                    'focus-visible:outline-offset-2 focus-visible:outline-teal-600',
                                                )}
                                            >
                                                {tier.planType == currentTier.planType ? '使用中' : '選擇此項'}
                                            </button>
                                            <p className='text-sm mt-2 text-teal-600'>以年計費</p>
                                            {
                                                tier.planType == PlanType.freeTrial && currentTier.planType == PlanType.freeTrial && data.personalplanexpireddate
                                                    ?
                                                    <p className='text-sm'>將於 {data.personalplanexpireddate.toLocaleString()} 到期 </p>
                                                    :
                                                    <></>
                                            }
                                            <ul role="list" className="mt-8 space-y-3 text-sm/6 text-gray-600">
                                                {tier.features.map((feature) => (
                                                    <li key={feature} className="flex gap-x-3">
                                                        <CheckIcon aria-hidden="true" className="h-6 w-5 flex-none text-teal-600" />
                                                        {feature}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    ))}
                                </div>

                                <div>
                                    <p className="mx-auto mt-12 text-md font-medium text-gray-600">
                                        基本關懷 : 由我們的個案管理師協助至您的客戶旁，進行口頭關照，詢問是否有任何需要協助處理的地方。
                                    </p><p className="mx-auto text-md font-medium text-gray-600">
                                        進階關懷 : 由我們的個案管理師協助至您的客戶旁進行關照，將包含小卡片小禮物，並且協助將客戶之意見傳達與院方協助處理。
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                    :
                    <></>
            }

            {
                data.plantype == PlanType.personal ?

                    <div className="flex justify-center items-center">
                        <div className="bg-white py-6">
                            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                                <div className="mx-auto max-w-4xl text-center">
                                    <h2 className="text-base/7 font-semibold text-teal-600">價格</h2>
                                    <p className="mt-2 text-balance text-5xl font-semibold tracking-tight text-gray-900">
                                        依照您的需求升級
                                    </p>
                                </div>
                                <p className="mx-auto mt-6 max-w-2xl text-pretty text-center text-lg font-medium text-gray-600 sm:text-xl/8">
                                    我們的方案主要區分在於AI諮詢數量，以及關懷之次數。我們會協助您使用此資金投資到您與您客戶的關係之中 !
                                </p>
                                <p className="mx-auto mt-6 max-w-2xl text-pretty text-center text-lg font-medium text-gray-600 sm:text-xl/8">
                                    你的客戶，我們照顧。
                                </p>
                                <div className="mx-auto mt-6 max-w-2xl rounded-3xl ring-1 ring-gray-200 lg:mx-0 lg:flex lg:max-w-none">
                                    <div className="p-8 sm:p-10 lg:flex-auto">
                                        <h3 className="text-3xl font-semibold tracking-tight text-gray-900">您正在使用: {currentTier.name} 方案</h3>
                                        <p className="mt-6 text-base/7 text-gray-600">
                                            {currentTier.description}
                                        </p>
                                        <div className="mt-10 flex items-center gap-x-4">
                                            <h4 className="flex-none text-sm/6 font-semibold text-teal-600">您的權益</h4>
                                            <div className="h-px flex-auto bg-gray-100" />
                                        </div>
                                        <ul role="list" className="mt-8 grid grid-cols-1 gap-4 text-sm/6 text-gray-600 sm:grid-cols-2 sm:gap-6">
                                            {currentTier.features.map((feature) => (
                                                <li key={feature} className="flex gap-x-3">
                                                    <CheckIcon aria-hidden="true" className="h-6 w-5 flex-none text-teal-600" />
                                                    {feature}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                    <div className="-mt-2 p-2 lg:mt-0 lg:w-full lg:max-w-md lg:shrink-0">
                                        <div className="rounded-2xl bg-gray-50 py-10 text-center ring-1 ring-inset ring-gray-900/5 lg:flex lg:flex-col lg:justify-center lg:py-16">
                                            <div className="mx-auto max-w-xs px-8">
                                                <p className="text-base font-semibold text-gray-600">當前價格</p>
                                                <p className="mt-6 flex items-baseline justify-center gap-x-2">
                                                    <span className="text-5xl font-semibold tracking-tight text-gray-900">{currentTier.price}</span>
                                                </p>

                                                <p className="mt-6 text-sm text-gray-600">
                                                    若有任何使用上問題或是想取消訂閱，請寄送 Email 至 service@ratetwansafe.com
                                                </p>
                                            </div>
                                        </div>
                                        <button
                                            onClick={() => {
                                                setOrgSelector(true);
                                            }}
                                            className="mt-10 block w-full rounded-md bg-teal-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-teal-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-600"
                                        >
                                            點此升級至團體購買
                                        </button>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                    :
                    <></>
            }
            {
                data.plantype == PlanType.group ?

                    <div className="flex justify-center items-center">
                        <div className="bg-white py-6">
                            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                                <div className="mx-auto max-w-4xl text-center">
                                    <h2 className="text-base/7 font-semibold text-teal-600">價格</h2>
                                    <p className="mt-2 text-balance text-5xl font-semibold tracking-tight text-gray-900">
                                        依照您的需求升級
                                    </p>
                                </div>
                                <p className="mx-auto mt-6 max-w-2xl text-pretty text-center text-lg font-medium text-gray-600 sm:text-xl/8">
                                    我們的方案主要區分在於AI諮詢數量，以及關懷之次數。我們會協助您使用此資金投資到您與您客戶的關係之中 !
                                </p>
                                <p className="mx-auto mt-6 max-w-2xl text-pretty text-center text-lg font-medium text-gray-600 sm:text-xl/8">
                                    你的客戶，我們照顧。
                                </p>
                                <div className="mx-auto mt-6 max-w-2xl rounded-3xl ring-1 ring-gray-200 lg:mx-0 lg:flex lg:max-w-none">
                                    <div className="p-8 sm:p-10 lg:flex-auto">
                                        <h3 className="text-3xl font-semibold tracking-tight text-gray-900">您正在使用: {currentTier.name} 方案</h3>
                                        <p className="mt-6 text-base/7 text-gray-600">
                                            {currentTier.description}
                                        </p>
                                        <div className="mt-10 flex items-center gap-x-4">
                                            <h4 className="flex-none text-sm/6 font-semibold text-teal-600">您的權益</h4>
                                            <div className="h-px flex-auto bg-gray-100" />
                                        </div>
                                        <ul role="list" className="mt-8 grid grid-cols-1 gap-4 text-sm/6 text-gray-600 sm:grid-cols-2 sm:gap-6">
                                            {currentTier.features.map((feature) => (
                                                <li key={feature} className="flex gap-x-3">
                                                    <CheckIcon aria-hidden="true" className="h-6 w-5 flex-none text-teal-600" />
                                                    {feature}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                    <div className="-mt-2 p-2 lg:mt-0 lg:w-full lg:max-w-md lg:shrink-0">
                                        <div className="rounded-2xl bg-gray-50 py-10 text-center ring-1 ring-inset ring-gray-900/5 lg:flex lg:flex-col lg:justify-center lg:py-16">
                                            <div className="mx-auto max-w-xs px-8">
                                                <p className="text-base font-semibold text-gray-600">當前價格</p>
                                                <p className="mt-6 flex items-baseline justify-center gap-x-2">
                                                    <span className="text-5xl font-semibold tracking-tight text-gray-900">{currentTier.price}</span>
                                                </p>
                                                {/* <a
                                                    href="#"
                                                    className="mt-10 block w-full rounded-md bg-teal-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-teal-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-600"
                                                >
                                                    Get access
                                                </a> */}

                                                <p className="mt-6 text-sm text-gray-600">
                                                    若有任何使用上問題或是想取消訂閱，請寄送 Email 至 service@ratetwansafe.com
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {
                                    isManager && ableUseOrgInvite ?
                                        <>

                                            <div className="mt-10 mx-auto max-w-4xl text-center">
                                                <h2 className="text-base/7 font-semibold text-teal-600">組織</h2>
                                                <p className="mt-2 text-balance text-5xl font-semibold tracking-tight text-gray-900">
                                                    您所管理之組織
                                                </p>
                                            </div>
                                            <div className="mt-10 max-w-[90vw] overflow-auto">
                                                <table className="text-left w-full text-sm font-light">
                                                    <thead className="border-b font-medium dark:border-neutral-500">
                                                        <tr>
                                                            <th scope="col" className="px-6 py-4">姓名</th>
                                                            <th scope="col" className="px-6 py-4">加入日期</th>
                                                            <th scope="col" className="px-6 py-4">管理</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr key='primary' className="border-b dark:border-neutral-500">
                                                            <td className="whitespace-nowrap px-6 py-4">
                                                                {
                                                                    useUserStore.getState().userData.name && useUserStore.getState().userData.name !== '' ?
                                                                        useUserStore.getState().userData.name :
                                                                        useUserStore.getState().userData.email
                                                                }
                                                                (您)
                                                            </td>
                                                            <td className="whitespace-nowrap px-6 py-4">
                                                                {
                                                                    membership.filter(item => item.publicUserData.userId == userId)[0]
                                                                        ?.createdAt.toLocaleString()
                                                                }
                                                            </td>
                                                            <td className="whitespace-nowrap px-6 py-4">
                                                            </td>
                                                        </tr>
                                                        {membership.filter(item => item.publicUserData.userId !== userId).map((row, index) => (
                                                            <tr key={index} className="border-b dark:border-neutral-500">
                                                                <td className="whitespace-nowrap px-6 py-4">{row.publicUserData.firstName} {row.publicUserData.lastName}</td>
                                                                <td className="whitespace-nowrap px-6 py-4">{row.createdAt.toLocaleString()}</td>
                                                                <td className="whitespace-nowrap px-6 py-4">

                                                                    <button
                                                                        onClick={() => { destroyMembership(row) }}
                                                                        type="button"
                                                                        className="inline-flex items-center gap-x-1.5 rounded-md 
                                                                            bg-red-500 px-1 mt-2 text-base font-semibold text-white 
                                                                            shadow-sm hover:bg-red-400 focus-visible:outline focus-visible:outline-2 
                                                                            focus-visible:outline-offset-2 focus-visible:outline-red-700"
                                                                    >
                                                                        <TrashIcon
                                                                            aria-hidden="true"
                                                                            className="w-5 h-5"
                                                                        />
                                                                        移除此人
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))}

                                                        {invite.map((row, index) => (
                                                            <tr key={index} className="border-b dark:border-neutral-500">
                                                                <td className="whitespace-nowrap px-6 py-4">{row.emailAddress}</td>
                                                                <td className="whitespace-nowrap px-6 py-4">{row.createdAt.toLocaleString()}</td>
                                                                <td className="whitespace-nowrap px-6 py-4">

                                                                    <button
                                                                        onClick={() => { revokeInvite(row) }}
                                                                        type="button"
                                                                        className="inline-flex items-center gap-x-1.5 rounded-md 
                                                                            bg-red-500 px-1 mt-2 text-base font-semibold text-white 
                                                                            shadow-sm hover:bg-red-400 focus-visible:outline focus-visible:outline-2 
                                                                            focus-visible:outline-offset-2 focus-visible:outline-red-700"
                                                                    >
                                                                        <TrashIcon
                                                                            aria-hidden="true"
                                                                            className="w-5 h-5"
                                                                        />
                                                                        移除此邀請
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                        {
                                                            organization?.maxAllowedMemberships &&
                                                                organization?.maxAllowedMemberships > invite.length + membership.length ?
                                                                <tr key={0} className="border-b dark:border-neutral-500">
                                                                    <td className="whitespace-nowrap px-6 py-4">請輸入 Email 進行邀請</td>
                                                                    <td className="whitespace-nowrap px-6 py-4">
                                                                        <input
                                                                            value={inviteEmail}
                                                                            onChange={(e) => setInviteEmail(e.target.value)}
                                                                        />
                                                                    </td>
                                                                    <td className="whitespace-nowrap px-6 py-4">

                                                                        <button
                                                                            onClick={() => { sendInvite() }}
                                                                            type="button"
                                                                            className="inline-flex items-center gap-x-1.5 rounded-md 
                                                                        bg-teal-500 px-1 mt-2 text-base font-semibold text-white 
                                                                        shadow-sm hover:bg-teal-400 focus-visible:outline focus-visible:outline-2 
                                                                        focus-visible:outline-offset-2 focus-visible:outline-teal-700"
                                                                        >
                                                                            <PlusIcon
                                                                                aria-hidden="true"
                                                                                className="w-5 h-5"
                                                                            />
                                                                            增加邀請
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                                :
                                                                <></>
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="mt-12 mb-12 flex justify-center">
                                            </div>
                                        </>
                                        :
                                        <>
                                            {isManager && !ableUseOrgInvite ?
                                                <>
                                                    <div className="mt-10 mx-auto max-w-4xl text-center">
                                                        <h2 className="text-base/7 font-semibold text-teal-600">組織</h2>
                                                        <p className="mt-2 text-balance text-5xl font-semibold tracking-tight text-gray-900">
                                                            您所管理之組織
                                                        </p>
                                                    </div>
                                                    <p className="mx-auto mt-6 max-w-2xl text-pretty text-center text-lg font-medium text-gray-600 sm:text-xl/8">
                                                        資料更新中...請重新整理網頁後嘗試。
                                                    </p>
                                                </>
                                                :
                                                <></>
                                            }
                                        </>
                                }
                            </div>
                        </div>

                    </div>

                    :
                    <></>
            }
        </>

    )
}